/**
 * Built-in English UI labels. These are the last stop of the label fallback chain
 * (selected language -> English AppLabels record -> these defaults -> the key), so the app is
 * fully usable before any AppLabels content has been bundled/downloaded, and offline.
 *
 * Keys are stable dotted ids; the AppLabels content type uses the same keys.
 */
export const DEFAULT_LABELS = {
  // Page navigation controls during an administration
  'nav.back': 'Back',
  'nav.continue': 'Continue',
  'nav.saveFinishLater': 'Save and finish later',
  'nav.done': 'Done',
  'nav.submitting': 'Submitting…',
  'nav.iAgree': 'I Agree',
  'nav.exit': 'Exit',

  // "Save and finish later" confirmation dialog
  'saveDialog.title': 'Save and Finish Later',
  'saveDialog.message': 'Your progress will be saved. You can continue this assessment later.',
  'saveDialog.continue': 'Continue Assessment',
  'saveDialog.confirm': 'Save & Finish Later',
} as const;

export type LabelKey = keyof typeof DEFAULT_LABELS;
